// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@stoneage/App/Store/Selectors/SettingsSelectors";

interface MarketoSettings {
    baseUrl: string;
    munchkinId: string;
    scriptUrl: string;
}

export function getMarketoSettings(state: ApplicationState): MarketoSettings {
    const customSettings = getSettingsCollection(state).customSettings;
    return {
        baseUrl: customSettings.marketoBaseUrl,
        munchkinId: customSettings.marketoMunchkinId,
        scriptUrl: customSettings.marketoScriptUrl,
    };
}
